export const RULES = {
  //Account Details
  ammountFormat: /^\d+(,\d{3})*\.?\d*$/,
  ammountFormat2: /^\d*(,\d+)*\.?\d*$/,
  dateFormat: /^[^\s].{9}$/,
  activationCode2: /^[0-9]{6}$/,
};
